/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteInsightShareInput = {|
  id: string,
  insightId: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deleteInsightShareMutationVariables = {|
  input: DeleteInsightShareInput
|};
export type deleteInsightShareMutationResponse = {|
  +deleteInsightShare: ?{|
    +deletedInsightShareId: ?string
  |}
|};
export type deleteInsightShareMutation = {|
  variables: deleteInsightShareMutationVariables,
  response: deleteInsightShareMutationResponse,
|};
*/


/*
mutation deleteInsightShareMutation(
  $input: DeleteInsightShareInput!
) {
  deleteInsightShare(input: $input) {
    deletedInsightShareId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteInsightShareInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteInsightSharePayload",
    "kind": "LinkedField",
    "name": "deleteInsightShare",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedInsightShareId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteInsightShareMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteInsightShareMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deleteInsightShareMutation",
    "operationKind": "mutation",
    "text": "mutation deleteInsightShareMutation(\n  $input: DeleteInsightShareInput!\n) {\n  deleteInsightShare(input: $input) {\n    deletedInsightShareId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8bd0d439870b4f4d5364416f5238e64c';

module.exports = node;
